import vosClient, { IVosResponse } from "../../vosClient";

export interface IGetApproveCreatorListParams {
  recUserId?: string;
  depId?: string;
}

export interface ApproveCreatorItemApprover {
  DutyType: "MAIN" | "SUB";
  HR_No: string;
  FullName: string;
  Name_Job_Title: string;
  Email: string;
}

export interface ApproveCreatorItem {
  Level: number;
  Title: string;
  Approvers: ApproveCreatorItemApprover[];
}

export class ApproveCreatorService {
  static async getApproveCreatorList(params?: IGetApproveCreatorListParams) {
    const response = await vosClient.get<IVosResponse<ApproveCreatorItem[]>>("/api/department/ticket-approve-creator", {
      params,
    });
    return response.data;
  }
}
